import { defineComponent as D, ref as E, computed as o, toRef as P, resolveComponent as C, openBlock as t, createElementBlock as a, normalizeClass as r, createElementVNode as s, withModifiers as O, createVNode as w, renderSlot as n, toDisplayString as y, withDirectives as I, vShow as B, Fragment as N, createCommentVNode as h, createTextVNode as V } from "vue";
import { usePopoverState as A } from "@onereach/ui-components-common/hooks";
import { O as H } from "./OrIcon-k8cyvh-D.mjs";
import { _ as j } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var i = /* @__PURE__ */ ((e) => (e.Default = "default", e.Card = "card", e))(i || {}), g = /* @__PURE__ */ ((e) => (e.Default = "default", e.Danger = "danger", e))(g || {}), v = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Inherit = "inherit", e))(v || {});
const z = [
  // Layout
  "layout-column"
], F = [
  // Typography
  "typography-caption-regular"
], L = [
  // Theme
  "theme-foreground-disabled",
  "dark:theme-foreground-disabled-dark"
], M = {
  [i.Default]: [
    // Spacing
    "gap-md"
  ],
  [i.Card]: [
    // Shape
    "rounded-md",
    // Spacing
    "px-md",
    "py-md",
    "gap-md"
  ]
}, R = {
  "primary-default": [],
  "primary-card": [
    // Theme
    "theme-background-surface-1",
    "dark:theme-background-surface-1-dark"
  ],
  "secondary-default": [],
  "secondary-card": [
    // Theme
    "theme-background-surface-3",
    "dark:theme-background-surface-3-dark"
  ],
  "inherit-default": [],
  "inherit-card": [
    // Theme
    "theme-background-inherit",
    "dark:theme-background-inherit"
  ]
}, T = [
  // Layout
  "layout-row",
  // Interactivity
  "interactivity-click",
  // Box
  "min-w-[16px]",
  // Spacing
  "gap-sm",
  // Typography
  "typography-body-2-bold",
  // Theme
  "outline-none"
], q = {
  default: [
    // Theme
    "theme-foreground-default",
    "dark:theme-foreground-default-dark",
    // Theme (hover)
    "hover:theme-foreground-primary",
    "dark:hover:theme-foreground-primary-dark",
    // Theme (focus)
    "focus-visible:theme-foreground-primary",
    "dark:focus-visible:theme-foreground-primary-dark",
    // Theme (active)
    "active:theme-foreground-primary",
    "dark:active:theme-foreground-primary-dark"
  ],
  danger: [
    // Theme
    "theme-foreground-error",
    "dark:theme-foreground-error-dark",
    // Theme (hover)
    "hover:theme-foreground-error-hover",
    "dark:hover:theme-foreground-error-hover-dark",
    // Theme (focus)
    "focus-visible:theme-foreground-error-hover",
    "dark:focus-visible:theme-foreground-error-hover-dark",
    // Theme (active)
    "active:theme-foreground-error-hover",
    "dark:active:theme-foreground-error-hover-dark"
  ]
}, G = [
  // Layout
  "contents",
  // Typography
  "typography-body-2-regular",
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], J = [
  // Spacing
  "ml-[28px] md:ml-[24px]"
], K = D({
  name: "OrExpansionPanel",
  components: {
    OrIcon: H
  },
  props: {
    label: {
      type: String,
      default: void 0
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    description: {
      type: String,
      default: void 0
    },
    variant: {
      type: String,
      default: () => i.Default
    },
    color: {
      type: String,
      default: () => g.Default
    },
    backgroundColor: {
      type: String,
      default: () => v.Primary
    },
    leftIndent: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    keepAlive: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:state",
    "open",
    "close"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, d) {
    const u = E(), c = o(() => [
      "or-expansion-panel-v3",
      ...z,
      ...M[e.variant],
      ...R[`${e.backgroundColor}-${e.variant}`]
    ]), p = o(() => [
      ...T,
      ...q[e.color]
    ]), f = o(() => [
      ...G
    ]), l = o(() => [
      e.leftIndent ? J : ""
    ]), m = o(() => [
      ...F,
      e.disabled ? L : ""
    ]), { state: k, open: b, close: S, toggle: $ } = A(P(e, "isOpen"), d.emit);
    return {
      root: u,
      rootStyles: c,
      headerStyles: p,
      addonStyles: f,
      contentStyles: l,
      descriptionStyles: m,
      state: k,
      open: b,
      close: S,
      toggle: $
    };
  }
}), Q = ["disabled"], U = {
  class: /* @__PURE__ */ r(["layout-row", "justify-between"])
}, W = ["tabindex", "disabled"], X = { class: "truncate" };
function Y(e, d, u, c, p, f) {
  const l = C("OrIcon");
  return t(), a("div", {
    ref: "root",
    class: r(e.rootStyles),
    disabled: e.disabled
  }, [
    s("div", U, [
      s("div", {
        class: r(e.headerStyles),
        tabindex: e.disabled ? null : 0,
        disabled: e.disabled,
        onClick: d[0] || (d[0] = O((m) => e.toggle(), ["stop"]))
      }, [
        w(l, {
          class: r([e.state === "open" ? "rotate-0" : "rotate-[-90deg]"]),
          icon: "expand_more",
          variant: "filled-bold"
        }, null, 8, ["class"]),
        n(e.$slots, "label", { state: e.state }, () => [
          s("span", X, y(e.label), 1)
        ])
      ], 10, W),
      s("div", {
        class: r(e.addonStyles)
      }, [
        n(e.$slots, "addon")
      ], 2)
    ]),
    e.keepAlive ? I((t(), a("div", {
      key: 0,
      class: r(e.contentStyles)
    }, [
      n(e.$slots, "default")
    ], 2)), [
      [B, e.state === "open"]
    ]) : (t(), a(N, { key: 1 }, [
      e.state === "open" ? (t(), a("div", {
        key: 0,
        class: r(e.contentStyles)
      }, [
        n(e.$slots, "default")
      ], 2)) : h("", !0)
    ], 64)),
    (e.description || e.$slots.description) && e.state != "open" ? (t(), a("div", {
      key: 2,
      class: r(e.descriptionStyles)
    }, [
      n(e.$slots, "description", {}, () => [
        V(y(e.description), 1)
      ])
    ], 2)) : h("", !0)
  ], 10, Q);
}
const re = /* @__PURE__ */ j(K, [["render", Y]]);
export {
  i as E,
  re as O,
  g as a,
  v as b
};
//# sourceMappingURL=OrExpansionPanel-BNGPdEnp.mjs.map
